module.exports = __webpack_public_path__ + "img/Feature.f304c703.jpg";